import { render, staticRenderFns } from "./QuestionField.vue?vue&type=template&id=bc1c781a"
import script from "./QuestionField.vue?vue&type=script&lang=js"
export * from "./QuestionField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports